<template>
  <Modal :value="value" @input="$emit('input', $event)">
    <p class="text-sm leading-tight">
      {{ $t('popups.exit.subtitle') }}
    </p>
    <p class="xl:text-1.5xl font-bold leading-tight pb-5 xl:pb-8">
      {{ $t('popups.exit.title') }}
    </p>
    <div class="flex">
      <Button
        id="flight-voucher-return-lh"
        variant="primary-border"
        class="mr-4"
        :href="backToLHLink"
      >
        {{ $t('popups.exit.cancelButton') }}
      </Button>
      <Button
        id="flight-voucher-continue"
        variant="secondary"
        @click="$emit('input', false)"
      >
        {{ $t('popups.exit.continueButton') }}
      </Button>
    </div>
  </Modal>
</template>

<script lang="ts">
import CancelRedemptionPopup from '~app/psp/base/cancel-redemption-popup.ts'
import Modal from '~brand-components/lufthansa/modal/modal.vue'
import Button from '~brand-components/lufthansa/button/button.vue'

export default CancelRedemptionPopup.extend({
  components: {
    Modal,
    Button,
  },
})
</script>
